import { Component, OnInit } from '@angular/core';
import { JeevesEditContactModalComponent } from 'gung-standard-jeeves';

@Component({
    selector: 'cult-cult-edit-contact-modal',
    templateUrl: './cult-edit-contact-modal.component.html',
    styleUrls: ['./cult-edit-contact-modal.component.scss'],
    standalone: false
})
export class CultEditContactModalComponent extends JeevesEditContactModalComponent {
  initForm() {
    this.contactForm = this.formBuilder.group({
      name: this.formBuilder.control(this.customerContact.name ? this.customerContact.name : ''),
      CS1: this.formBuilder.group({
        comkod: '1',
        comnr: this.formBuilder.control(this.customerContact.extra.CS1 ? this.customerContact.extra.CS1.comnr : '')
      }),
      CS4: this.formBuilder.group({
        comkod: '4',
        comnr: this.formBuilder.control(this.customerContact.extra.CS4 ? this.customerContact.extra.CS4.comnr : '')
      }),
      CS3: this.formBuilder.group({
        comkod: '3',
        comnr: this.formBuilder.control(this.customerContact.extra.CS3 ? this.customerContact.extra.CS3.comnr : '')
      })
    });
  }
}